import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const WordGroups = ({ module, onDelete }) => {
  const { t } = useLanguage();

  const handleDelete = (group) => {
    const confirmed = window.confirm(
      `${t('areYouSureDeleteWordGroup')} "${group.name}"?`
    );

    if (confirmed) {
      onDelete(group.id);
    }
  };
  
  if (!module || !module.word_groups || !module.word_groups.length) {
    return <p style={{ color: '#888', fontStyle: 'italic', marginTop: '2rem' }}>{t('noWordGroupsYet')}</p>;
  }
  
  // Get total words from module's num_words column (from Supabase)
  const totalWords = module.num_words || 0;
  
  return (
    <div style={{ marginTop: '2rem' }}>
      <h3 style={{ color: '#2c6e49', fontWeight: 600, textAlign: 'left' }}>{t('wordGroups')}</h3>
      <div style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1rem', textAlign: 'left' }}>
        {totalWords} {t('flashcard', totalWords)} {t('total')}
      </div>
      <div>
        {module.word_groups.map((group, idx) => {
          const flashcardCount = group.num_words || 0;
          
          return (
            <div key={group.id || idx} className="card" style={{ padding: '1.5rem', textAlign: 'center' }}>
              <div style={{ marginBottom: '1rem' }}>
            <strong style={{fontSize: '1.1rem', fontWeight: 500}}>{group.name}</strong>
                <div style={{ color: '#666', fontSize: '0.9rem', marginTop: '0.5rem' }}>
                  {flashcardCount} {t('flashcard', flashcardCount)}
                </div>
              </div>
              <div style={{display: 'flex', gap: '1rem', justifyContent: 'center'}}>
                <Link to={`/module/${module.id}/group/${group.id}`} className="btn btn-primary">{t('view')}</Link>
                {onDelete && (
                  <button 
                    onClick={() => handleDelete(group)} 
                    className="btn btn-danger"
                    aria-label={`${t('delete')} ${group.name}`}
                  >
                    {t('delete')}
                  </button>
                )}
              </div>
          </div>
          );
        })}
      </div>
    </div>
  );
};

export default WordGroups; 
